import styled from 'styled-components';

import { TOP_NAVBAR_HEIGHT } from '@web/components/TopNavbar';

export const OuterWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: calc(100vh - ${TOP_NAVBAR_HEIGHT}px);
`;

export const InnerWrapper = styled.div`
  display: grid;
  flex: 1;
  grid-template: 'sidebar content' 1fr / 225px 1fr;
  margin: 0 auto;
  min-height: 0;
  width: min(1220px, 100%);
`;

export const SidebarWrapper = styled.div`
  grid-area: sidebar;
  min-height: 0;
`;

export const ContentWrapper = styled.div`
  grid-area: content;
  min-height: 0;
`;
